import React from "react";
import heroImage from "../../assets/more-affordable-img-1.png";
import GlowButton from "./GlowButton";
import DatapointBadges from "./DatapointBadges";

const MoreAffordableScroll = () => {
  return (
    <section
      className="
        flex flex-col md:flex-row justify-between items-center
        w-full px-4 sm:px-6 md:px-12 lg:px-12
        py-20 md:py-16
        text-white min-h-screen mt-24 sm:mt-0 md:mt-2 pb-[12rem] lg-xl:mt-[90px] xl-2xl:mt-16
        overflow-x-hidden
      "
    >
      {/* LEFT SECTION */}
      <div className="flex justify-center items-center w-full md:w-1/2 mt-0 lg-xl:mt-[-10rem] md:mt-0 md:mr-[-1rem] lg-xl:mr-[-1rem] xl-2xl:mr-[-5.3rem]">
        <div
          className="
            grid
            max-w-[650px]
            w-[240px] sm:w-[350px] md:w-[340px] lg-xl:w-[440px] xl-2xl:w-[550px]
            h-[250px] sm:h-[360px] md:h-[380px] lg-xl:h-[480px] xl-2xl:h-[600px]
            p-0
            rounded-2xl overflow-hidden
          "
        >
          <div className="w-full h-full rounded-xl overflow-hidden">
            <img
              src={heroImage}
              alt="more affordable illustration"
              className="w-full h-full object-cover rounded-xl"
            />
          </div>
        </div>
      </div>

      {/* RIGHT SECTION */}
      <div className="max-w-3xl text-center md:text-left space-y-5 w-full md:w-1/2 mt-6 sm:mt-8 md:mt-0 lg-xl:pb-[200px] xl-2xl:pb-[50px]">
        <h1 className="text-3xl sm:text-3xl md:text-5xl lg:text-[70px] font-lexend font-bold leading-tight">
          <span className="text-[#FCBA05]">more affordable</span> than the rest, smarter for you!
        </h1>
        <p className="text-[#FCBA05] font-lexend font-bold text-2xl sm:text-3xl md:text-4xl lg:text-[48px] leading-tight">
          serve more, spend less!
        </p>

        <p className="text-gray-200 leading-relaxed text-sm sm:text-base md:text-lg lg:text-xl font-poppins mt-6 max-w-lg md:max-w-xl mx-auto md:mx-0">
          beɘmz combines continuous ordering, customer and inventory management, along with
          innovative ai support, improving customer loyalty and your bottom line. low fixed fee,
          no commission promise — your revenue is yours!
        </p>

        {/* Datapoints badges */}
        <DatapointBadges keys={["increase_revenue", "reduce_cost"]} className="justify-center md:justify-start" />

        {/* CTA Buttons */}
        <div className="flex flex-wrap justify-center md:justify-start gap-4 mt-[10px] sm:mt-[20px] xl-2xl:mt-[30px]">
          <button
            onClick={() => window.location.href = "/business/demo"}
            className="inline-flex items-center justify-center whitespace-nowrap border border-[#6E3FC6] bg-[#e9d9ff] hover:bg-[#d8bfff] text-black text-sm sm:text-base font-medium px-[18px] sm:px-[25px] lg:px-[40px] rounded-full transition-all duration-300 cursor-pointer"
          >
            how it works
          </button>
          <GlowButton btnValue="free trial" btn1="2" onClick={() => window.location.href = "/business/get-started"} />
        </div>
      </div>
    </section>
  );
};

export default MoreAffordableScroll;
